import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = ["id"]
const _hoisted_3 = ["onClick"]

import { OrderStatus } from '@/coreDomainsModule/entities/arrival';
import OrderStatusBadge from './OrderStatusBadge.vue';
import SvgLoader from '@/utils/SvgLoader.vue';
import { computed, onBeforeUnmount, onMounted, ref } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'OrderStatusSelectInput',
  props: {
    index: {},
    modelValue: { default: OrderStatus.Unknown },
    disabled: { type: Boolean },
    availableStatus: { default: undefined },
    exceptStatus: { default: undefined }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

_useCssVars(_ctx => ({
  "16c96498": (`${dropdownWidth.value + 8}px`)
}))

const props = __props;

const emits = __emit;

const isDropdownOpening = ref(false);

const containerId = computed(() => `order-status-select-input__container-${props.index}`);
const dropdownId = computed(() => `order-status-select-input__dropdown-${props.index}`);

const dropdownWidth = computed(() => document.getElementById(containerId.value)?.clientWidth ?? 0);

const orderStatusOptions = computed(() => {
  if (props.availableStatus) {
    return props.availableStatus;
  }
  if (props.exceptStatus) {
    return Object.fromEntries(Object.entries(OrderStatus).filter(([key]) => !(props.exceptStatus ?? []).includes(key as OrderStatus)));
  }
  return OrderStatus;
});

/**
 * アウトサイドクリックでドロップダウンを閉じる
 * @param event - MouseEvent
 */
const closeDropdown = (event: MouseEvent) => {
  const target = event.target;
  if (!(target instanceof Element) || target.closest(`#${containerId.value}`) || target.closest(`#${dropdownId.value}`)) return;
  isDropdownOpening.value = false;
};

/**
 * ドロップダウンを切り替える
 */
const toggleDropdown = () => {
  isDropdownOpening.value = !isDropdownOpening.value;
};

onMounted(() => {
  document.addEventListener('click', closeDropdown);
});

onBeforeUnmount(() => {
  document.removeEventListener('click', closeDropdown);
});

/**
 * 選択肢をクリックした際の動作
 * @param value - 選択したOrderStatus
 */
const onSelectOption = (value: OrderStatus) => {
  isDropdownOpening.value = false;
  emits('update:modelValue', value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("button", {
      id: containerId.value,
      class: _normalizeClass(["order-status-select-input__container", { 'order-status-select-input--disabled': _ctx.disabled }]),
      onClick: toggleDropdown
    }, [
      _createVNode(OrderStatusBadge, { "order-status-str": _ctx.modelValue }, null, 8, ["order-status-str"]),
      _createVNode(SvgLoader, { name: "arrowDown" })
    ], 10, _hoisted_1),
    (isDropdownOpening.value && !_ctx.disabled)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          id: dropdownId.value,
          class: "order-status-select-input__dropdown"
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orderStatusOptions.value, (orderStatus) => {
            return (_openBlock(), _createElementBlock("button", {
              key: orderStatus,
              class: "order-status-select-input__option",
              onClick: ($event: any) => (onSelectOption(orderStatus))
            }, [
              _createVNode(OrderStatusBadge, { "order-status-str": orderStatus }, null, 8, ["order-status-str"])
            ], 8, _hoisted_3))
          }), 128))
        ], 8, _hoisted_2))
      : _createCommentVNode("", true)
  ], 64))
}
}

})